module.exports = __webpack_public_path__ + "img/marta.577a04b0.jpeg";